export const BRAND_NAME = "Collavue";
export const TAGLINE = "Find the perfect YouTube creator for your brand.";
